var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSuccessB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\t\t\t.a-icon-success-b{fill:rgba(0,227,84,0.2);}.b-icon-success-b{fill:none;stroke:#00d14d;stroke-width:3px;}\n\t\t"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-389 -302)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a-icon-success-b",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(389 302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b-icon-success-b",
    d: "M0,28.129l13.313.438L12.373,0",
    transform: "translate(423.983 312.384) rotate(45)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccessB);
export default __webpack_public_path__ + "static/media/icon-success_b.fc321b4e48378f124d01794d45aead1e.svg";
export { ForwardRef as ReactComponent };